import {
  GET_COUPON_PROJECTS,
  GET_COUPON_PROJECTS_SUCCESS,
  GET_COUPON_PROJECTS_ERROR,
} from './../../actionType.js'

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
}

const GetCouponProject = (state = initialState, action) => {
  switch (action.type) {
    case GET_COUPON_PROJECTS:
      state = {
        ...state,
        data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      }
      break

    case GET_COUPON_PROJECTS_SUCCESS:
      state = {
        ...state,
        data: action.payload.results,
        loading: false,
        success: true,
        error: false,
        message: null,
      }
      break

    case GET_COUPON_PROJECTS_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      }
      break

    default:
      state = { ...state }
      break
  }
  return state
}

export default GetCouponProject
